import React, { Component, createRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { PlayBtn, PauseBtn, CertificateIcon } from "../imagepath";
import "./videoCarousel.css";

const teacherComments = [
  {
    name: "Lisa Quimby, Senior State investigator State Licensing Division",
    comment:
      "State mandates expect us to know what to do, but they never provide real training. AngelWatch finally gives us a real plan of action."
  },
  {
    name: "James Carter, Officer",
    comment:
      "AngelWatch is far superior to any police-led school training because it is designed for educators, not officers. It prepares teachers for what they actually face in real emergencies.",
  },
  {
    name: "Lisa Mendoza, Daycare Owner Director",
    comment:
      "This training was eye-opening. I learned more in a few hours than I did in years of traditional emergency training."
  },
  {
    name: "Rachel Collins, High School Teacher",
    comment:
      "Every educator should take this course. It gave me practical tools that I can use in my classroom immediately.",
  },
  {
    name: "Michael Trent, Charter School Director",
    comment:
      "We switched to AngelWatch from another program, and the difference is night and day. This is the best emergency training available.",
  },
  {
    name: "Jessica Ramirez, Preschool Teacher",
    comment:
      "After completing AngelWatch’s training, I finally feel like I know exactly what to do if an emergency happens."
  },
  {
    name: "Emily Harris, Kindergarten Teacher",
    comment:
      "After taking the AngelWatch course, I finally feel prepared for any emergency—and that peace of mind is truly priceless.",
  },
  {
    name: "Lauren Mitchell, Kindergarten Teacher",
    comment:
      "This is the best training I’ve seen in 25+ years of education. My staff feels confident and prepared.",
  },
  {
    name: "Karen Williams, Assistant Principal",
    comment:
      "I no longer feel anxious about emergencies at my school. AngelWatch has given us a system that actually works."
  },
  {
    name: "Sarah O’Connor, Daycare Director",
    comment:
      "As a daycare owner, I need to ensure my staff is trained. AngelWatch not only meets state requirements but goes beyond to ensure real-world readiness.",
  },
  {
    name: "James Monroe, Elementary School Teacher",
    comment:
      "In all my years of teaching, I’ve never taken a course this thorough and effective. It truly stands out above the rest.",
  },
  {
    name: "Tom Williams, Superintendent",
    comment:
      "AngelWatch is the most realistic, engaging, and effective safety training we’ve ever had. Every school should be using this program.",
  },
];

class VideoCarousel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 1,
      },
      tablet: {
        breakpoint: { max: 1024, min: 769 },
        items: 2,
        slidesToSlide: 1,
      },
      mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1,
        slidesToSlide: 1,
      },
    };

    return (
      <div className="video-testimonial">
        <Carousel
          arrows={true}
          responsive={responsive}
          autoPlaySpeed={1000}
          transitionDuration={500}
          customLeftArrow={<button className="custom-arrow left1">{"<-"}</button>}
          customRightArrow={<button className="custom-arrow right1">{"->"}</button>}
        >
          {teacherComments.map((comment, index) => (
            <div key={index} className="video-content">
              <div className="relative">
                <img
                  className="carousel-video"
                  src={require(`../../assets/video/teachers/${index + 1}.jpg`)}
                >
                </img>
              </div>
              <div className="video-card">
                <p className="video-card_teacher-name">{comment.name}</p>
                <p className="video-card_teacher-comment">{comment.comment}</p>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    );
  }
}

export default VideoCarousel;
